import { useState } from "react";
import type { PinMode } from "../../../../shared/pins";
import type { Tournament } from "../../lib/useTournament";
import { PinEntry } from "../player/Pin";

/**
 * The admin screen until this phone has typed its admin PIN (decision 40). The first time an
 * admin link opens on a phone it asks for a new PIN (typed twice) if this admin has none, or for
 * the PIN. The phone remembers it for this tournament. Until then the screen is sent nothing
 * secret: no links, no log, and it can change nothing.
 */
export function AdminLock({ t }: { t: Tournament }) {
  const id = t.identity;
  const [told, setTold] = useState<PinMode | null>(null);
  const mode: PinMode = told ?? (id?.pinSet ? "enter" : "set");
  const named = id?.owner === false;
  const who = named && id?.name ? id.name : null;
  const reset = t.signedOut?.as === "admin" ? t.signedOut.reason : null;

  return (
    <section className="ad-card ad-who ad-lock">
      <h2>{mode === "set" ? "Set your admin PIN" : "Admin PIN"}</h2>
      {reset && <p className="ad-note"><b>{reset}</b></p>}
      <p className="ad-note">
        {mode === "set"
          ? `${who ? `Hello ${who}. ` : ""}Pick four numbers only you know. Anyone who opens this admin link needs them too. This phone remembers them, so you type them once.`
          : `${who ? `${who}, type` : "Type"} your admin PIN. This phone remembers it after this.`}
      </p>
      <PinEntry
        key={mode}
        mode={mode}
        yes={mode === "set" ? "Set my admin PIN" : "Open"}
        send={(pin) => t.adminPin(pin, mode)}
        onAnswer={(a) => {
          if (a.ok) t.clearSignedOut();
          // set from another phone a moment ago, or reset: change step
          else if (a.set !== undefined && (a.set ? "enter" : "set") !== mode) setTold(a.set ? "enter" : "set");
        }}
      />
      <p className="ad-note">
        {mode === "set"
          ? "It can be the same as your player PIN."
          : named
            ? "Forgotten it? Any other admin can reset it from More, Admins."
            : "Forgotten it? Reset it from a phone where the owner's screen is already open."}
      </p>
    </section>
  );
}
